import { useState } from 'react';
import { Plus, Truck, Users, X } from 'lucide-react';
import { getStoredDriverMobileUser } from '../utils/driverMobileSession';
import { isCorporateExternalTransportMobileUser } from '../utils/corporateMobileUser';

export function CorporateQuickActions() {
  const [open, setOpen] = useState(false);
  const user = getStoredDriverMobileUser<any>();

  if (!isCorporateExternalTransportMobileUser(user)) return null;

  const actions = [
    { label: 'Sürücülerim', icon: Users, path: '/driver-mobile-corporate-drivers' },
    { label: 'Çekicilerim', icon: Truck, path: '/driver-mobile-corporate-vehicles' },
  ];

  return (
    <div className="fixed bottom-2 right-3 z-[60]" style={{ bottom: 'calc(var(--driver-nav-height) + var(--safe-area-bottom) + 0.5rem)' }}>
      {open && (
        <div className="absolute bottom-20 right-0 flex flex-col gap-2">
          {actions.map(({ label, icon: Icon, path }) => (
            <div key={label} className="flex items-center justify-end">
            <button
              type="button"
              onClick={() => { setOpen(false); window.location.href = path; }}
              className="inline-flex min-w-44 items-center justify-between gap-3 rounded-full border border-emerald-500 bg-emerald-600 px-4 py-3 text-sm font-bold text-black shadow-lg transition-transform hover:scale-105 hover:bg-emerald-500 dark:border-emerald-400 dark:bg-emerald-600 dark:text-black"
            >
              <span>{label}</span><Icon className="h-5 w-5 text-white" />
            </button>
            </div>
          ))}
        </div>
      )}
      <button
        type="button"
        aria-label={open ? 'Hızlı menüyü kapat' : 'Kurumsal hızlı menü'}
        onClick={() => setOpen((value) => !value)}
        className="flex h-16 w-16 items-center justify-center rounded-full bg-emerald-600 text-white shadow-2xl ring-4 ring-white/90 transition-transform hover:bg-emerald-700 active:scale-95 dark:ring-slate-900/80"
      >
        {open ? <X className="h-6 w-6" /> : <Plus className="h-7 w-7" />}
      </button>
    </div>
  );
}
